import { AdminBar } from './AdminBar';
import { Breadcrumb } from './Breadcrumb';
import { Content } from './Content';
import { FooterComponent } from './Footer';
import { Header } from './Header';
import { Metas } from './Metas';
import { Page } from './Page';
import { RGPDBanner } from './RGPD';
import { Shortcuts } from './Shortcuts';

export default Object.assign(Page, {
  AdminBar,
  Header,
  Footer: FooterComponent,
  Content,
  Breadcrumb,
  RGPDBanner,
  Shortcuts,
  Metas,
});
